import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, Grid, List, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Network, SocialAccount } from 'api';
import { CustomSVG, Numeric } from 'components';
import { useCurrentUser, useSocialConnections } from 'hooks';
import { Account } from 'Links';

import Item from './Reach/Item';
import ClientFollowers from './Reach/ClientFollowers';
import ConnectTwitter from './Reach/ConnectTwitter';
import ConnectLinkedIn from './Reach/ConnectLinkedIn';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '16px 16px 0',
  },
  reach: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: theme.typography.fontWeightBold,
  },
  list: {
    padding: '8px 0',
  },
  perNetworkReach: {
    color: theme.custom.palette.grey1,
  },
  button: {
    padding: '8px 0',
  },
}));

const TotalReach: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { follower_count, reach } = useCurrentUser();
  const connections = useSocialConnections();

  function renderItem(account: SocialAccount) {
    return <Item key={account.id} account={account} />;
  }

  function renderList() {
    const twitterStats = connections.filter(conn => conn.provider === Network.Twitter);
    const linkedInStats = connections.filter(conn => conn.provider === Network.Linkedin);

    return (
      <List className={classes.list}>
        <ClientFollowers />
        {twitterStats.length ? twitterStats.map(renderItem) : <ConnectTwitter />}
        {linkedInStats.length ? linkedInStats.map(renderItem) : <ConnectLinkedIn />}
      </List>
    );
  }

  return (
    <Paper className={classes.root}>
      <Typography variant="subtitle2">{t('user:myTotalReach')}</Typography>
      <Grid container alignItems="center" spacing={1}>
        <Grid item>
          <CustomSVG color="primary" name="network" />
        </Grid>
        <Grid item>
          <Typography variant="h4" className={classes.reach}>
            <Numeric value={follower_count + reach} />
          </Typography>
        </Grid>
      </Grid>
      <Divider />
      {renderList()}
      {!!connections.length && (
        <Fragment>
          <Divider />
          <Button component={Account} fullWidth className={classes.button}>
            {t('sharing:connectMore')}
          </Button>
        </Fragment>
      )}
    </Paper>
  );
};

export default TotalReach;
